import api from './api';

export const signIn = async (credentials) => {
    try {
        const response = await api.post('/auth/signin', credentials);
        if (response.status === 200) return response.data;
        return false;
    } catch (error) {
        console.log(error);
        return false;
    }
};

export const signUp = async (userData) => {
    try {
        const response = await api.post('/auth/signup', userData);
        if (response.status === 201) return response.data;
        return false;
    } catch (error) {
        console.log(error);
        return false;
    }
};

export const signInSocialMedia = async (userData) => {
    try {
        const response = await api.post('/auth/signinSocialMedia', userData);
        if (response.status === 200) return response.data;
        return false;
    } catch (error) {
        console.log(error);
        return false;
    }
};